import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Component, OnInit, Input, AfterViewInit, TemplateRef, OnDestroy} from '@angular/core';
import { Actividad, Tarea, Const } from '@app/shared';
import { isUndefined } from 'lodash';
import { ConfigTask, CssStatus } from '../shared/util';
import { ConfigRefineTasks, HelperFlowService, FlowMode } from '../shared/helper-flow.service';
import { NotifierService } from '../shared/notifier.service';
import { AuthenticationService } from '@app/core';
import { Subject } from 'rxjs';

// Lista de estados para la actividad
const cssStatus = Const.CSS_STATUS;
const status = {
  finalizado: cssStatus.finished,
  pendiente: cssStatus.pending,
  inactivo: cssStatus.inactive
};
type typeNotification = 'newActivity' | 'editActivity' | 'removeActivity' | 'newTask';

@Component({
  selector: 'iw-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit, AfterViewInit, OnDestroy {
  // Contiene el tipo de proceso que se esta renderizando
  @Input() typeProcess = 'process';
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  @Input() isDesignTask = 'compact';
  // Id del tramite actual
  @Input() idTramite: number;
  // Determina si esta actividad pertenece a un trámite por default o una instancia
  @Input() belongsToInstance = true;
  // Determina si es la primer actividad activa
  @Input() isFirstActiveActivity = false;
  // Contiene el encabezado del flujo
  @Input() headerFlow: TemplateRef<any>;
  // Actividad actual
  @Input()
  set activity(v: Actividad) {
    // Validar si el estado coincide con una key de "states"
    if (status.hasOwnProperty(v.actividad_estado.nombre)) {
      this._status = status[v.actividad_estado.nombre];
    } else {
      this._status = status.pendiente;
    }
    // Si es la ultima actividad de un flujo de una instancia,
    // no se colapsan las tareas.
    // if (this.belongsToInstance) {
    //   this.isCollapsedTasks = v.meta.isLast ? false : true;
    // }
    // if (v.actividad_estado && v.actividad_estado.nombre === Const.STATUS_ACTIVITY.pending) {
    //   this.isCollapsedTasks = false;
    // }
    this.tasks = this.hfs.refineTasks(v, this.configRefineTasks);
    this._actividad = v;
  }
  get activity() {
    return this._actividad;
  }
  // Estado de la actividad
  get status() {
    return this._status;
  }

  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false,
  };

  // get tasks() {
  //   return this.hfs.refineTasks(this.activity, this.configRefineTasks);
  // }
  // Determina si se esta realizando alguna petición al backend
  @Input() isLoading = false;
  // Oculta el componente del fantasma
  @Input() ghostHidden = 0;
  // Configuración para la refinación de las tareas
  @Input() configRefineTasks: Partial<ConfigRefineTasks> = {};
  // Configuración global de la tarea
  @Input() configTask: Partial<ConfigTask> = {};
  // Determina el comportamiento de la actividad con respecto al flujo
  @Input() flowMode: FlowMode = 'normal';
  // Determina la instancia de donde se esta ejecutando el flujo
  @Input() typeProcessInstance: string;
  // Muestra las tareas
  isCollapsedTasks = false;
  // Contiene informacion que se desee compartir en caso de dar click a la tarea
  @Input() sharedData: any;
  // Tareas refinadas
  tasks: Tarea[];
  private _status: CssStatus;
  private _actividad: Actividad;
  // Controla si se muestra las tareas asociadas
  private destroy: Subject<void> = new Subject<void>();

  constructor(
    private ns: NotifierService,
    private hfs: HelperFlowService,
    private sts: ScrollToService,
    private as: AuthenticationService
  ) { }

  ngOnInit() {
    if (!this.belongsToInstance) {
      this.activateAction.created = this.as.confirmPermission(
        Const.types_permissions.administrationProcess,
        Const.types_action_permissions.created,
      );
      this.activateAction.update = this.as.confirmPermission(
        Const.types_permissions.administrationProcess,
        Const.types_action_permissions.update,
      );
      this.activateAction.delete = this.as.confirmPermission(
        Const.types_permissions.administrationProcess,
        Const.types_action_permissions.delete,
      );
    }
  }

  ngAfterViewInit() {
    // Mover el scroll a la primer actividad activa
    if (this.isFirstActiveActivity) {
      this.sts.scrollTo({
        target: 'isFirstActivityActive'
      } as ScrollToConfigOptions);
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Valida si se puede mostrar una determinada tarea en el flujo.
   *
   * @param {Tarea} task
   * @returns {boolean}
   * @memberof ActivityComponent
   */
  showTask(task: Tarea): boolean {
    let res = true;
    const fbrs = this.configTask.filterByRootStatus;
    if (!isUndefined(fbrs)) {
      res = task.activo === fbrs ? true : false;
    }
    return res;
  }
} // End class



// WEBPACK FOOTER //
// ./src/app/flow/activity/activity.component.ts